export enum FilterType {
  FUNCTIONAL_GROUP = 'FUNCTIONAL_GROUP',
  TEXT = 'TEXT',
  NUMBER = 'NUMBER',
}
export const FILTER_TYPES_KEYS = Object.keys(FilterType) as [
  keyof typeof FilterType
];
export const RULE_TYPE_QUERY = 'QUERY';

export enum QueryOperator {
  AND = 'AND',
  OR = 'OR',
}
export const QUERY_OPERATOR_TYPE_KEYS = Object.keys(QueryOperator) as [
  keyof typeof QueryOperator
];
